app.service('basketBundle', function (loading, modal, broker, log, console, pageConfig, simpleToastr) {

	function logAdd(data) {
		let parent = pageConfig.getData('basket').items.filter(i => i.cartId == data.mainCartItemId);
		if (parent.length) {
			parent = parent[0];

			log.event({
				id: 'to_cart',
				f03: 'cart_step_1',
				f04: data.productId, 	//plu folijki
				f05: 'product',
				f06: parent.plu, // plu rodzica
				f07: 'Koszyk',	//miejsce
				f08: 'bundle',	//miejsce dodania
				f09: 'new',
				f10: pageConfig.getData('order').isInstalmentPayment ? 'installment' : 'cash'
			});

			UA.push({
				event: "add_to_cart",
				ecommerce: {
					items: [{
						item_id: data.productId, //numer PLU (wartość zmienna)   
						item_list_name: 'Koszyk - Bundle', // nazwa listy produktowej (stała wartość)
						item_list_id: 'Koszyk', //identyfikator listy produktowej (stała wartość)
						item_list_parent: parent.plu
					}]
				}
			});
		}
	}
	function addBundle(data) {
		console.log(data);
		if (data.productId && data.mainCartItemId && data.bundleId) {
			loading.start();
			logAdd(data);
			$.ajax({
				type: 'POST',
				url: '/add-bundle-promotional-product-to-cart.ltr',
				data: {
					productId: data.productId,
					mainCartItemId: data.mainCartItemId,
					addedFrom: 'TO_CART',
					bundleId: data.bundleId
				},
				success: function (result) {

					if (result.status === 'FAIL' && result.errorMessage) {
						modal.alert(result.errorMessage);
					}
					else {
						simpleToastr.afterReloadMessage(result.afterReloadMessage);
						broker.trigger('REFRESH_BASKET_VIEW');
					}
				},
				error: function () {
					modal.alert('Błąd dodawania promocji. Spróbuj ponownie');
				}
			});
		} else {
			console.log('Brakuje danych do dodania produktu')
		}
	}

	function init() {
		$('.js-add-bundle').on('click', function () {
			addBundle({
				bundleId: $(this).data('bundle'),
				productId: $(this).data('product'),
				mainCartItemId: $(this).data('cart')
			});
		});
		$('.js-open-bundle').on('click', function () {
			log.event({
				id: 'bundle-add',
				f03: $(this).data('bundle'),
				f04: $(this).data('product')
			});
		});
	}

	return {
		init
	};
});
